var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClimateSolutions = function SvgClimateSolutions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:none;stroke:#222;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#4bceeb",
    "data-name": "Ellipse 321"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    d: "m31 34.5.41-3a27.68 27.68 0 0 0-.72-11l-.92-3.36-.92 3.36a27.68 27.68 0 0 0-.72 11l.43 3.08",
    className: "cls-2",
    "data-name": "Path 2327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    d: "m28 35.69-3.07.66a27.69 27.69 0 0 0-10.13 4.44l-2.84 2 3.47-.29A27.72 27.72 0 0 0 26 39.43l2.84-1.5",
    className: "cls-2",
    "data-name": "Path 2328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    d: "m30.5 38 2.67 1.4a27.51 27.51 0 0 0 10.6 3.1l3.47.28-2.85-2a27.38 27.38 0 0 0-10.11-4.44l-2.8-.6",
    className: "cls-2",
    "data-name": "Path 2329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    d: "M28.71 37.57 26.24 61a1.38 1.38 0 0 0 1.23 1.52h4.44a1.38 1.38 0 0 0 1.38-1.38v-.15L30.8 37.54",
    className: "cls-2",
    "data-name": "Path 2330"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_63",
    d: "M26.54 59.58h6.44",
    className: "cls-2",
    "data-name": "Line 63"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    cx: 29.76,
    cy: 36.13,
    r: 1.72,
    className: "cls-2",
    "data-name": "Ellipse 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_64",
    d: "m58.92 62.57-.08-24.83",
    className: "cls-2",
    "data-name": "Line 64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    d: "M57.61 53.52a9.2 9.2 0 0 1-8-9.12c0-5.07 4.11-19.31 9.2-19.31s9.2 14.24 9.2 19.31a9.2 9.2 0 0 1-8.31 9.16",
    className: "cls-2",
    "data-name": "Path 2331"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_65",
    d: "m54.93 42.24 3.68 3.68",
    className: "cls-2",
    "data-name": "Line 65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    d: "m61.27 41.45-2.2 2.2",
    className: "cls-2",
    "data-name": "Line 66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_67",
    d: "m62.75 45.85-3.68 3.68",
    className: "cls-2",
    "data-name": "Line 67"
  }))))));
};
export default SvgClimateSolutions;